import { parseISO, set, differenceInMinutes, addMinutes, isAfter, isBefore } from "date-fns";
import { CLINIC_STARTING_HOUR, CLINIC_ENDING_HOUR, SLOT_TIME } from "../appointment-schedule.constants.js";
import { GenericEventType } from "../appointment-schedule.types.js";
const getEmptyCalendarSlots = (items, nonWorkingTimes) => {
  const updateFreeSlots = (values, date, employeeReferenceId) => {
    var _a, _b, _c;
    const blockers = ((_b = (_a = nonWorkingTimes == null ? void 0 : nonWorkingTimes[date]) == null ? void 0 : _a[employeeReferenceId]) == null ? void 0 : _b.filter(({ type }) => type === GenericEventType.BLOCKER)) ?? [];
    const sortedItemsByStart = [...values, ...blockers].sort((a, b) => a.start.getTime() - b.start.getTime());
    const parsedDate = parseISO(date);
    const dayStart = set(parsedDate, { hours: CLINIC_STARTING_HOUR, minutes: 0, seconds: 0, milliseconds: 0 });
    const dayEnd = set(parsedDate, { hours: CLINIC_ENDING_HOUR, minutes: 0, seconds: 0, milliseconds: 0 });
    const gapBetweenFirstAppointmentAndDayStart = differenceInMinutes(
      ((_c = sortedItemsByStart == null ? void 0 : sortedItemsByStart[0]) == null ? void 0 : _c.start) ?? dayEnd,
      dayStart
    );
    const initialValue = gapBetweenFirstAppointmentAndDayStart >= SLOT_TIME ? [
      {
        start: dayStart,
        end: addMinutes(dayStart, gapBetweenFirstAppointmentAndDayStart),
        employeeReferenceId
      }
    ] : [];
    return sortedItemsByStart.reduce((slots, item, index, array) => {
      const { employeeReferenceId: referenceId } = item;
      const nextSlot = array[index + 1];
      const previousSlot = array[index - 1];
      const usePreviousAppointmentStart = previousSlot && isAfter(previousSlot.end, item.end) && isBefore(previousSlot.end, dayEnd);
      const start = usePreviousAppointmentStart ? previousSlot.end : item.end;
      const slotToAdd = {
        start,
        end: dayEnd,
        employeeReferenceId: referenceId
      };
      if (!nextSlot) {
        return differenceInMinutes(dayEnd, item.end) >= SLOT_TIME ? [...slots, slotToAdd] : slots;
      }
      const gapBetweenAppointments = differenceInMinutes(nextSlot.start, item.end);
      if (gapBetweenAppointments >= SLOT_TIME) {
        return [
          ...slots,
          {
            ...slotToAdd,
            end: nextSlot.start
          }
        ];
      }
      return slots;
    }, initialValue);
  };
  return Object.entries(items).reduce(
    (daysAccumulator, [currentDay, dayValues]) => ({
      ...daysAccumulator,
      [currentDay]: Object.entries(dayValues).reduce(
        (employeeAccumulator, [currentEmployee, employeeValues]) => ({
          ...employeeAccumulator,
          [currentEmployee]: updateFreeSlots(employeeValues, currentDay, currentEmployee)
        }),
        {}
      )
    }),
    {}
  );
};
export {
  getEmptyCalendarSlots
};
